import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import React from 'react';

export default function index({ onClick = () => {}, changeIcon = false }) {
	return (
		<span className="show-password" onClick={onClick}>
			{changeIcon ? <EyeOutlined /> : <EyeInvisibleOutlined />}
		</span>
	);
}
